export interface LabelValue {
  label: string;
  value: string;
}
